/**
 * Feature flag IDs used in the VITE_FEATURE_MANAGEMENT JSON.
 * Always use these constants instead of raw string literals.
 */
export const FEATURE_IDS = {
  EmailLogin: "EmailLogin",
  KretaLogin: "KretaLogin",
  GoogleLogin: "GoogleLogin",
  ElteLogin: "ElteLogin",
  Register: "Register",
} as const;

export type FeatureId = (typeof FEATURE_IDS)[keyof typeof FEATURE_IDS];
